import { ReactNode } from 'react'

interface FormLayoutProps {
  footer?: ReactNode
  children: ReactNode
  onSubmit: () => void
}

export const FormLayout = ({ footer, children, onSubmit }: FormLayoutProps) => (
  <form onSubmit={onSubmit} className="size-full">
    <div className="flex size-full flex-col gap-6">{children}</div>
    {footer && (
      <div
        className="fixed bottom-0 right-0 z-10 w-full border-t border-border-secondary bg-fg-primary py-4 pl-[180px] sm:pl-[240px]"
        data-id="fixed-form-panel"
      >
        <div className="mx-auto flex max-w-[1144px] justify-end gap-1 px-2 sm:gap-3 sm:px-4">{footer}</div>
      </div>
    )}
  </form>
)
